import JsonApi from 'devour-client';
import { ServiceBase } from './ServiceBase';
import { SiteTypePayload } from '../payloads/SiteTypePayload';
import { RatePayload } from 'services/interfaces/RatePayload';

export class SiteTypeService extends ServiceBase<SiteTypePayload> {
  constructor(jsonApi: JsonApi) {
    const schema = SiteTypePayload.getSchema();

    super(jsonApi, 'site_type', schema, SiteTypePayload);
    super.define('rates', RatePayload);
  }

  async getAll(parkId?: string) {
    const parks = await super.find({
      include: 'rates',
      filter: { park_id: parkId },
      page: { number: 1, size: 200 },
    });
    return parks;
  }
}
